export default __webpack_public_path__ + "static/media/customer-service.8a407fe4.svg";